import { render, staticRenderFns } from "./RecuperarSenhaInfo.vue?vue&type=template&id=8fea859c&"
import script from "./RecuperarSenhaInfo.vue?vue&type=script&lang=js&"
export * from "./RecuperarSenhaInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports